import React, { Component, lazy, Suspense } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import axios from "axios";
import ThankYou from "./ThankYou";
import Decline from "./Decline";
import CircularProgress from "@material-ui/core/CircularProgress";
import Step1 from "./Step1";
import ProgressBar from "../ProgressBar/progressBar";
const Step2 = lazy(() => import("./Step2"));
const Step3 = lazy(() => import("./Step3"));
const Step4 = lazy(() => import("./Step4"));
const Step5 = lazy(() => import("./Step5"));
const Step6 = lazy(() => import("./Step6"));
const Step7 = lazy(() => import("./Step7"));
const Step8 = lazy(() => import("./Step8"));
const Step9 = lazy(() => import("./Step9"));
const Step10 = lazy(() => import("./Step10"));
const Step11 = lazy(() => import("./Step11"));
const Step11a = lazy(() => import("./step11a"));
const Step12 = lazy(() => import("./Step12"));
const Step13 = lazy(() => import("./Step13"));
const Step14 = lazy(() => import("./Step14"));
const Step15 = lazy(() => import("./Step15"));
const Step16 = lazy(() => import("./Step16"));
const Step17 = lazy(() => import("./Step17"));
const Step18 = lazy(() => import("./Step18"));
const Step19 = lazy(() => import("./Step19"));
const Step19a = lazy(() => import("./Step19.1"));
const Step20 = lazy(() => import("./Step20"));
const Step20a = lazy(() => import("./Step20a"));
const Step20b = lazy(() => import("./Step20b"));
const Step21 = lazy(() => import("./Step21"));
const Step21a = lazy(() => import("./Step21a"));
const Step22 = lazy(() => import("./Step22"));
const Step23 = lazy(() => import("./Step23"));
const defaultState = {
  // step1
  firstName: "",
  middleName: "",
  lastName: "",

  // step2
  DocumentType: "",

  // step3
  DOB: "",

  // step4
  sex: -1,

  //step5
  bornlatLng: {},
  bornStreetAddress: "",
  bornAptUnitNo: "",
  bornCity: "",
  bornStateCountry: "",
  bornZipCode: "",

  // step6
  ssn: "",

  // step7
  email: "",

  // step8
  phone: "",

  // step9
  mailinglatLng: {},
  mailingstreetAddress: "",
  mailingFormattedAddress: "",
  mailingUnitType: "",
  mailingUnitNo: "",
  mailingcity: "",
  mailingstate: "",
  mailingcountry: "",
  mailingzipCode: "",

  // step10
  ListoFNameA: "",
  ListoFNameB: "",

  // step11
  parent1firstName: "",
  parent1lastName: "",
  parent1DoB: "",
  parent1PlaceOfBirth: "",
  parent1Sex: "2",
  parent1CitizenShip: "1",

  // step11 a
  parent2firstName: "",
  parent2lastName: "",
  parent2DoB: "",
  parent2PlaceOfBirth: "",
  parent2Sex: "1",
  parent2CitizenShip: "1",

  // step12
  married: "",

  // step13
  spouseFirstName: "",
  spouseLastName: "",

  // step14:
  spouseDOB: "",
  physicalAddressDifferent: false,
  // step15
  spouseaptUnitNo: "",
  spouselatLng: {},
  spousestreetAddress: "",
  spousecity: "",
  spousestate: "",
  spousezipCode: "",
  cardDetails: {},
  paymentAddress: {},
  // step16
  spouseCitizenShip: "",

  // step17
  dateMarried: "",

  //step18
  divorced: "",
  dateDivorcedORWidowed: "",

  // step19
  additionalphone: "",
  additionalPhoneType: "i do not have another number",

  //step 19a
  Occupation: "",
  employerOrSchool: "",

  //step 20
  height: 0,
  weight: 0,
  feet: "",
  eyeColor: "",
  hairColor: "",

  //step 20a
  departureDate: "",
  returnDate: "",
  countriesToVisited: "",
  mailingstreetAddressDisplay: "",
  emergencyAddressDisplay: "",
  emergencyAddress: {},
  paymentAddressDisplay: "",
  //step 20b
  permanentlatLng: {},
  permanentstreetAddress: "",
  permanentFormattedAddress: "",
  permanentaptUnitNo: "",
  permanentcity: "",
  permanentstate: "",
  permanentzipCode: "",

  // step21
  emergencyFullName: "",
  emergencylatLng: {},
  emergencystreetAddress: "",
  emergencyFormattedAddress: "",
  emergencyaptUnitNo: "",
  emergencycity: "",
  emergencystate: "",
  emergencyzipCode: "",
  emergencyPhone: "",
  emergencyRelationship: "",

  // step22
  usPassport: "",
  PassportBookOrCard: "",

  passportBookNumber: "",
  nameOnPassportBook: "",
  passportBookIssueDate: "",
  passportBookStatus: "",

  passportCardNumber: "",
  nameOnPassportCard: "",
  passportCardIssueDate: "",
  passportCardStatus: "",

  // step23
  creditCardNumber: "",
  cvv: "",
  exp: "",
  nameOnCard: "",
  paymentzipcode: "",

  TransactionData: {},
  // step24

  // step25
  agree: "",

  // step6
  franchiseOfCompany: "",

  // step7
  growsRevenueFor12Months: "",

  isLoader: false,
  //address page change
  page5: false,
  page9: false,
  page21: false,
  page1: false,
  page20: false,
  //prime cloud
  isCloudStorageEnabled: Boolean,
  messagePrimeCloud: "",
};

export default class MultiStepForm extends Component {
  state = defaultState;
  componentDidMount = () => {
    window.onbeforeunload = (event) => {
      const e = event || window.event;
      e.preventDefault();
      if (e) {
        e.returnValue = "";
      }
      return "";
    };
  };
  handleChangeState = (newState) => {
    this.setState(newState, () => {
      localStorage.setItem("ChangeAddressState", JSON.stringify(this.state));
    });
  };

  handleChangeField = (e, name, value) => {
    this.setState(
      {
        [name]: value,
      },
      () => {
        localStorage.setItem("PassportState", JSON.stringify(this.state));
      }
    );
  };

  dateConversion(date) {
    if (!date) {
      return "";
    }
    let splitedDate = date.split("-");
    if (splitedDate.length === 3) {
      return (
        (splitedDate[0].length === 1 ? "0" + splitedDate[0] : splitedDate[0]) +
        "" +
        (splitedDate[1].length === 1 ? "0" + splitedDate[1] : splitedDate[1]) +
        "" +
        splitedDate[2]
      );
    } else {
      return "";
    }
    // return (splitedDate.length>=1?(splitedDate[0].length===1?"0"+splitedDate[0]:splitedDate[0]):"")+""+(splitedDate.length>=2?(splitedDate[1].length===1?"0"+splitedDate[1]:splitedDate[1]):"")+""+splitedDate.length===3?splitedDate[2]:""
  }

  replaceFunction(value, symbol) {
    if (!value) {
      return "";
    }
    var returnValue = "";
    let splitedValue = value.split(symbol);
    if (splitedValue.length) {
      for (var i = 0; i < splitedValue.length; i++) {
        returnValue += splitedValue[i];
        if (i === splitedValue.length - 1) {
          return returnValue;
        }
      }
    } else {
      return value;
    }
  }
  getData() {
    var data = {
      // Start Page 1
      DocumentType: this.state.DocumentType,

      //Step 1
      Part1Line1LastName: this.state.lastName,
      Part1Line1FirstName: this.state.firstName,
      Part1Line1MiddleName: this.state.middleName,

      //Step 3
      Part1Line2DateBirth: this.dateConversion(this.state.DOB),

      //Step 4
      Line3Sex:
        this.state.sex === "male" ? 1 : this.state.sex === "female" ? 2 : -1,

      //Step 5
      Line4BirthPlace: this.state.bornCity + " " + this.state.bornStateCountry,

      //Step 6

      //Step 7
      Line6Email: this.state.email,

      //Step 8
      Line7Primarycontactnumber: this.state.phone.replace(/[-)( ]/g, ""),

      //Step 9mailingFormattedAddress
      Line81MailingAddress: this.state.mailingstreetAddress,
      Line82Address: `${this.state.mailingUnitType} ${this.state.mailingUnitNo}`,
      Line8City: this.state.mailingcity,
      Line8State: this.state.mailingstate,
      Line8Zipcode: this.state.mailingzipCode,
      Line8Country: this.state.mailingcountry,

      // Step 10
      Line9ListoFNameA: this.state.ListoFNameA,
      Line9ListoFNameB: this.state.ListoFNameB,

      // End Page 1

      // Start Page 3
      Page3FullName: `${this.state.lastName} ${this.state.firstName} ${this.state.middleName}`,
      Page3DOB: this.dateConversion(this.state.DOB),

      // Step 11
      Page3Line10FirstName: this.state.parent1firstName,
      Page3Line10LastName: this.state.parent1lastName,
      Page3Line10BirthPlace: this.state.parent1PlaceOfBirth,
      Page3Line10Sex: this.state.parent1Sex,
      Page3Line10USCitizen: this.state.parent1CitizenShip,
      Page3Parent1DOB: this.dateConversion(this.state.parent1DoB),

      // Step 11
      Page3Line10FirstName1: this.state.parent2firstName,
      Page3Line10LastName1: this.state.parent2lastName,
      Page3Line10BirthPlace1: this.state.parent2PlaceOfBirth,
      Page3Line10Sex1: this.state.parent2Sex,
      Page3Line10USCitizen1: this.state.parent2CitizenShip,
      Page3Parent2DOB: this.dateConversion(this.state.parent2DoB),

      //Step 12
      Page3Line11Married: this.state.married,

      //Step 13 , 14 , 15 , 16, 17, 18
      Page3Line11SpouseName: `${this.state.spouseFirstName} ${this.state.spouseLastName}`,
      Page3Line11DOB: this.dateConversion(this.state.spouseDOB),
      Page3Line11BirthPlace: `${this.state.spousecity} ${this.state.spousestate}`,
      Page3Line11USCitizen: this.state.spouseCitizenShip,
      Page3Line11MarriageDate: this.dateConversion(this.state.dateMarried),
      Page3Line11Divorced: this.state.divorced,
      Page3Line11DivorceDate: this.dateConversion(
        this.state.dateDivorcedORWidowed
      ),

      //Step 19
      Page3Line12Phone: this.state.additionalphone.replace(/[-)( ]/g, ""),
      Page3Line12PhoneType: this.state.additionalPhoneType,

      //Step 19 a
      Page3Line13Occupation: this.state.Occupation,
      Page3Line14School: this.state.employerOrSchool,

      //Step 20
      Page3Line15Height: this.state.height,
      Page3Line16Haircolor: this.state.hairColor,
      Page3Line17Eyecolors: this.state.eyeColor,

      // Step 20 a
      Page3Line18Depaturedate: this.dateConversion(this.state.departureDate),
      Page3Line18Returndate: this.dateConversion(this.state.returnDate),
      Page3Line18Countriesvisited: this.state.countriesToVisited,

      //Step 20 b
      Page3Line19Permanentaddress: this.state.physicalAddressDifferent
        ? this.state.permanentstreetAddress
        : this.state.mailingstreetAddressDisplay,
      Page3Line19Unit: this.state.physicalAddressDifferent
        ? this.state.permanentaptUnitNo
        : "",
      Page3Line19City: this.state.physicalAddressDifferent
        ? this.state.permanentcity
        : this.state.mailingstreetAddress.city,
      Page3Line19State: this.state.physicalAddressDifferent
        ? this.state.permanentstate
        : this.state.state,
      Page3Line19Zipcode: this.state.physicalAddressDifferent
        ? this.state.permanentzipCode
        : this.state.zipcode,

      //Step 21
      Page3Line20EmerName: `${this.state.emergencyFullName}`,

      Page3Line20Addeess: this.state.emergencyAddress.street,
      Page3Line20Unit: this.state.emergencyaptUnitNo,
      Page3Line20City: this.state.emergencyAddress.city,
      Page3Line20State: this.state.emergencyAddress.state,
      Page3Line20Zipcode: this.state.emergencyAddress.zipCode,
      Page3Line20UnitPhone: this.state.emergencyPhone.replace(/[-)( ]/g, ""),
      Page3Line20Relationship: this.state.emergencyRelationship,

      //Step 22
      Page3Line21PassportType: this.state.usPassport,
      Page3Line21NameInPassBook: this.state.nameOnPassportBook,
      Page3Line21BookNo: this.state.passportBookNumber,
      Page3Line21PassportBookIssueDate: this.dateConversion(
        this.state.passportBookIssueDate
      ),
      Page3Line21PassportBookStatus: this.state.passportBookStatus,

      Page3Line21NameInPassportCard: this.state.nameOnPassportCard,
      Page3Line21PassportCardNo: this.state.passportCardNumber,
      Page3Line21PassportCardIssueDate: this.dateConversion(
        this.state.passportCardIssueDate
      ),
      Page3Line21PassportCardStatus: this.state.passportCardStatus,

      // Payment
      CustomerEmail: this.state.email,
      CustomerFirstName: this.state.firstName,
      CustomerLastName: this.state.lastName,

      cardHolderName: this.state.cardDetails.nameOnCard,
      cardNumber: this.state.cardDetails.creditCardNumber,
      phone: this.state.phone.replace(/[-)( ]/g, ""),
      ssn: this.replaceFunction(this.state.ssn, "-"),
      paymentAddress: this.state.paymentAddress,
      emergencyAddress: this.state.emergencyAddress,
      bornAddress: this.state.bornAddress,
      transactionId:
        this.state.TransactionData && this.state.TransactionData.TransactionID,
      mailingstreetAddress: this.state.mailingstreetAddress,
      categoryId: "4",
    };
    return data;
  }

  submitData() {
    const newData = this.getData();

    var config = {
      headers: {
        "Content-Type": "application/json",
        "Accept-Encoding": "gzip, deflate, br",
        "Access-Control-Allow-Origin": "*",
        Authorization:
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.IjVmODY5MzA4NjJkMzM1NjZjODM3MmE0M2M2NjNmZTY0YWI1NmNiZGQ3YzNjOTRkNjUwNmEyZDA0MDk4ZmU5ZDJiNzJlZmU5ZmZlZGIwNWY4NjkzMDg2MmQzOWZhOTJmYjExMTVjYTQzZWZhODFkN2E2N2Q3YWY2YWE1NWY4NjkzMDg2MmQ3NyI.xfUaw9qF0uz2NXlLt2qCl5fA1byP77nAtPTvF_IqCr4",
      },
    };

    if (
      Object.keys(this.state.TransactionData).length > 0 &&
      !this.state.isLoader
    ) {
      this.setState({ isLoader: true });
      axios
        .post(
          // "https://passportdocpros.com/api/Passport",
          // "https://4a3eb8f99e9f.ngrok.io/api/passport",
          "passport.php",
          JSON.stringify(newData),
          config
        )
        .then((response) => {
          this.setState(defaultState);
          this.setState({ isLoader: false });
          localStorage.removeItem("PassportState");
        })
        .finally(() => {})
        .catch((err) => {
          this.setState(defaultState);
        });
    }
  }

  calculateAge() {
    const year = parseInt(this.state.DOB.substr(0, 4));
    var today = new Date();
    var age = today.getFullYear() - year;
    return age;
  }

  renderStep = (props) => {
    const { history } = props;
    const { path, params } = props.match;
    if (params.step === "thankyou") {
      if (!this.state.isLoader) {
        this.submitData();
      }
      return <ThankYou isLoader={this.state.isLoader} />;
    } else if (params.step === "decline") {
      return <Decline />;
    }
    const renderLoader = () => (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <CircularProgress />
      </div>
    );
    const step = parseInt(params.step);
    const currentPath = `/${path.split("/")[1]}`;
    switch (step) {
      case 1:
        return (
          <Suspense fallback={renderLoader()}>
            <Step1
              history={history}
              nextStep={`${currentPath}/2`}
              state={this.state}
              onChangeField={this.handleChangeField}
            />
          </Suspense>
        );
      case 2:
        return (
          <Suspense fallback={renderLoader()}>
            <Step2
              history={history}
              prevStep={`${currentPath}/1`}
              nextStep={`${currentPath}/3`}
              state={this.state}
              onChangeField={this.handleChangeField}
            />
          </Suspense>
        );
      case 3:
        return (
          <Suspense fallback={renderLoader()}>
            <Step3
              history={history}
              prevStep={`${currentPath}/2`}
              nextStep={`${currentPath}/4`}
              state={this.state}
              onChangeField={this.handleChangeField}
            />
          </Suspense>
        );
      case 4:
        return (
          <Suspense fallback={renderLoader()}>
            <Step4
              history={history}
              prevStep={`${currentPath}/3`}
              nextStep={`${currentPath}/5`}
              state={this.state}
              onChangeField={this.handleChangeField}
            />
          </Suspense>
        );
      case 5:
        return (
          <Suspense fallback={renderLoader()}>
            <Step5
              history={history}
              prevStep={`${currentPath}/4`}
              nextStep={`${currentPath}/6`}
              state={this.state}
              onChangeField={this.handleChangeField}
              onChangeState={this.handleChangeState}
            />
          </Suspense>
        );
      case 6:
        return (
          <Suspense fallback={renderLoader()}>
            <Step6
              history={history}
              prevStep={`${currentPath}/5`}
              nextStep={`${currentPath}/7`}
              state={this.state}
              onChangeField={this.handleChangeField}
            />
          </Suspense>
        );
      case 7:
        return (
          <Suspense fallback={renderLoader()}>
            <Step7
              history={history}
              prevStep={`${currentPath}/6`}
              nextStep={`${currentPath}/8`}
              state={this.state}
              onChangeField={this.handleChangeField}
            />
          </Suspense>
        );
      case 8:
        return (
          <Suspense fallback={renderLoader()}>
            <Step8
              history={history}
              prevStep={`${currentPath}/7`}
              nextStep={`${currentPath}/9`}
              state={this.state}
              onChangeField={this.handleChangeField}
            />
          </Suspense>
        );
      case 9:
        return (
          <Suspense fallback={renderLoader()}>
            <Step9
              history={history}
              prevStep={`${currentPath}/8`}
              nextStep={`${currentPath}/10`}
              state={this.state}
              onChangeField={this.handleChangeField}
              onChangeState={this.handleChangeState}
            />
          </Suspense>
        );
      case 10:
        return (
          <Suspense fallback={renderLoader()}>
            <Step10
              history={history}
              prevStep={`${currentPath}/9`}
              nextStep={`${currentPath}/11`}
              state={this.state}
              onChangeField={this.handleChangeField}
            />
          </Suspense>
        );
      case 11:
        return (
          <Suspense fallback={renderLoader()}>
            <Step11
              history={history}
              prevStep={`${currentPath}/10`}
              nextStep={`${currentPath}/12`}
              state={this.state}
              onChangeField={this.handleChangeField}
            />
          </Suspense>
        );
      case 12: //28
        return (
          <Suspense fallback={renderLoader()}>
            <Step11a
              history={history}
              prevStep={`${currentPath}/11`}
              nextStep={`${currentPath}/13`}
              state={this.state}
              onChangeField={this.handleChangeField}
            />
          </Suspense>
        );
      case 13: //12
        return (
          <Suspense fallback={renderLoader()}>
            <Step12
              history={history}
              state={this.state}
              prevStep={`${currentPath}/12`}
              nextStep={`${currentPath}/14`}
              unmarriedNextStep={`${currentPath}/22`}
              onChangeField={this.handleChangeField}
            />
          </Suspense>
        );
      case 14: //13
        return (
          <Suspense fallback={renderLoader()}>
            <Step13
              history={history}
              prevStep={`${currentPath}/13`}
              nextStep={`${currentPath}/15`}
              state={this.state}
              onChangeField={this.handleChangeField}
            />
          </Suspense>
        );
      case 15: //14
        return (
          <Suspense fallback={renderLoader()}>
            <Step14
              history={history}
              prevStep={`${currentPath}/14`}
              nextStep={`${currentPath}/16`}
              state={this.state}
              onChangeField={this.handleChangeField}
            />
          </Suspense>
        );
      case 16: //15
        return (
          <Suspense fallback={renderLoader()}>
            <Step15
              history={history}
              prevStep={`${currentPath}/15`}
              nextStep={`${currentPath}/17`}
              state={this.state}
              onChangeField={this.handleChangeField}
            />
          </Suspense>
        );

      case 17: //16
        return (
          <Suspense fallback={renderLoader()}>
            <Step16
              history={history}
              prevStep={`${currentPath}/16`}
              nextStep={`${currentPath}/18`}
              state={this.state}
              onChangeField={this.handleChangeField}
            />
          </Suspense>
        );
      case 18: //17
        return (
          <Suspense fallback={renderLoader()}>
            <Step17
              history={history}
              prevStep={`${currentPath}/17`}
              nextStep={`${currentPath}/19`}
              state={this.state}
              onChangeField={this.handleChangeField}
            />
          </Suspense>
        );
      case 19: //18
        return (
          <Suspense fallback={renderLoader()}>
            <Step18
              history={history}
              prevStep={`${currentPath}/18`}
              nextStep={`${currentPath}/20`}
              state={this.state}
              onChangeField={this.handleChangeField}
            />
          </Suspense>
        );
      case 20: //19
        return (
          <Suspense fallback={renderLoader()}>
            <Step19
              history={history}
              prevStep={
                this.state.married === "1"
                  ? `${currentPath}/19`
                  : `${currentPath}/13`
              }
              nextStep={
                this.calculateAge() > 16
                  ? `${currentPath}/21`
                  : `${currentPath}/21`
              }
              state={this.state}
              onChangeField={this.handleChangeField}
            />
          </Suspense>
        );
      case 21: //20
        return (
          <Suspense fallback={renderLoader()}>
            <Step19a
              history={history}
              prevStep={`${currentPath}/20`}
              nextStep={`${currentPath}/22`}
              state={this.state}
              onChangeField={this.handleChangeField}
            />
          </Suspense>
        );
      case 22: //21
        return (
          <Suspense fallback={renderLoader()}>
            <Step20
              history={history}
              unmarriedPrevStep={`${currentPath}/13`}
              marriedPrevStep={`${currentPath}/19`}
              // prevStep={
              //   this.calculateAge() > 16
              //     ? `${currentPath}/21`
              //     : `${currentPath}/20`
              // }
              nextStep={`${currentPath}/23`}
              state={this.state}
              onChangeField={this.handleChangeField}
            />
          </Suspense>
        );
      case 23: //26
        return (
          <Suspense fallback={renderLoader()}>
            <Step20b
              history={history}
              prevStep={`${currentPath}/22`}
              nextStep={`${currentPath}/24`}
              state={this.state}
              onChangeField={this.handleChangeField}
            />
          </Suspense>
        );
      case 24: //25
        return (
          <Suspense fallback={renderLoader()}>
            <Step20a
              history={history}
              prevStep={`${currentPath}/23`}
              nextStep={`${currentPath}/25`}
              state={this.state}
              onChangeField={this.handleChangeField}
            />
          </Suspense>
        );
      case 25: //22
        return (
          <Suspense fallback={renderLoader()}>
            <Step21
              history={history}
              prevStep={`${currentPath}/24`}
              nextStep={`${currentPath}/26`}
              state={this.state}
              onChangeField={this.handleChangeField}
            />
          </Suspense>
        );
      case 26: //22
        return (
          <Suspense fallback={renderLoader()}>
            <Step21a
              history={history}
              prevStep={`${currentPath}/25`}
              nextStep={`${currentPath}/27`}
              state={this.state}
              onChangeField={this.handleChangeField}
              onChangeState={this.handleChangeState}
            />
          </Suspense>
        );
      case 27: //23
        return (
          <Suspense fallback={renderLoader()}>
            <Step22
              history={history}
              prevStep={`${currentPath}/26`}
              nextStep={`${currentPath}/28`}
              state={this.state}
              onChangeField={this.handleChangeField}
            />
          </Suspense>
        );
      case 28: //24
        return (
          <Suspense fallback={renderLoader()}>
            <Step23
              history={history}
              prevStep={`${currentPath}/27`}
              nextStep={`${currentPath}/thankyou`}
              state={this.state}
              onChangeState={this.handleChangeState}
              onChangeField={this.handleChangeField}
            />
          </Suspense>
        );

      default:
        return <div>invalid step</div>;
    }
  };

  render() {
    const { path } = this.props.match;
    return (
      <Switch>
        <Route
          path="/start"
          exact
          render={() => <Redirect to={`${path}/1`} />}
        />
        <Route
          path={`${path}/:step`}
          render={(props) => (
            <>
              <ProgressBar step={props.match.params.step} />
              {this.renderStep(props)}
            </>
          )}
        />
      </Switch>
    );
  }
}
